import React from 'react';
import { CardWrapperGridProps } from '@/components/cards-wrapper-grid/types';
import Card from '@/components/card/Card';
import clsx from 'clsx';
import { Headline } from '../headline/Headline';
import Icon from '@/components/icon/Icon';

const GRID_COLS_CLASS: Record<number, string> = {
  1: 'lg:grid-cols-1',
  2: 'lg:grid-cols-2',
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4',
  5: 'lg:grid-cols-5',
};

const CardWrapperGrid: React.FC<CardWrapperGridProps> = ({
  cards,
  className,
  theme,
  gridCols,
  spacingBottom,
  spacingTop,
  headline,
  subtitle,
  subHeadline,
  icon,
  textAlign,
  select,
  classNameGrid,
}) => {
  const localTheme = theme === 'dark' ? 'bg-brand-100' : 'bg-white';
  const textAlignClass = clsx(
    textAlign === 'left' && 'items-start justify-start',
    textAlign === 'center' && 'items-center justify-center',
    textAlign === 'right' && 'items-end justify-end',
  );

  const gridColsClass = GRID_COLS_CLASS[gridCols ?? 0] ?? '';

  return (
    <div
      className={clsx(
        'relative mx-auto flex w-full flex-col gap-8',
        localTheme,
        {
          'pt-4 md:pt-8 lg:pt-20': spacingTop,
          'pb-4 md:pb-8 lg:pb-20': spacingBottom,
        },
      )}
    >
      <div className={clsx('container mx-auto flex flex-col', textAlignClass)}>
        {icon && (
          <div className="icon flex h-12 w-12 items-center justify-center rounded-xl bg-black">
            <Icon {...icon} />
          </div>
        )}
        {headline && (
          <Headline {...headline} className="mb-4 text-brand-700">
            {headline.title}
          </Headline>
        )}
        <div className="wrapper flex w-full flex-col items-start justify-between sm:flex-row sm:items-center">
          <div className="wrapper-headline flex flex-col gap-2">
            {subtitle && (
              <p className="text-2xl font-medium text-black">{subtitle}</p>
            )}

            {subHeadline && (
              <p
                className={clsx(
                  'text-base font-normal text-neutral-500',
                  select ? 'w-full' : 'sm:w-1/2',
                )}
              >
                {subHeadline}
              </p>
            )}
          </div>
          {select && (
            <div className="mt-4">
              <select
                onChange={(e) => select.onChange?.(e.target.value)}
                className="w-[250px] rounded-lg border border-neutral-100 px-3 py-2 text-base"
              >
                {select.options.map((option, i) => (
                  <option key={i} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
      <div
        className={clsx(
          'container relative z-10 mx-auto grid gap-6 sm:grid-cols-1 md:grid-cols-2',
          gridColsClass,
          classNameGrid,
          localTheme,
        )}
      >
        {cards.map((cardProps, index) => (
          <div
            key={index}
            className={clsx('card-item self-stretch', className)}
          >
            <Card {...cardProps} className="h-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardWrapperGrid;
